import React from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate, useLocation } from 'react-router-dom';

import { LangSwitch, useI18n } from '../i18n/I18nContext';
import { HOME_PALETTE as P } from '../homeTheme';

/**
 * Top bar for /home only.
 *
 * Deliberately not Topbar: Topbar is shared with the untranslated legacy /live
 * board and carries the env switcher, sign-out and build stamp. This bar is
 * translated and carries the three-way page nav instead. If the nav is later
 * wanted app-wide, the two should merge rather than both exist.
 *
 * Tenant name is hardcoded until there is a tenant concept to read it from.
 */

const TENANT = 'Stuttgart S-Bahn';

const ITEMS: { key: string; route: string }[] = [
  { key: 'home.nav.liveBoard', route: '/live2' },
  { key: 'home.nav.liveMap',   route: '/analysis/coverage' },
  { key: 'home.nav.analytics', route: '/analysis/messages' },
];

const HomeNav: React.FC = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Box sx={{
      backgroundColor: P.navBg,
      display: 'flex', alignItems: 'center', gap: 3,
      px: { xs: 2, md: 4 }, py: 1.25, flexWrap: 'wrap',
    }}>
      <Box
        component="img"
        src="/logo.png"
        alt="OpenCapacity"
        onClick={() => navigate('/home')}
        sx={{ height: 32, cursor: 'pointer' }}
      />

      <Box component="nav" sx={{ display: 'flex', gap: 2.5, flex: 1, minWidth: 0 }}>
        {ITEMS.map(item => {
          const active = pathname === item.route;
          return (
            <Box
              key={item.route}
              component="button"
              onClick={() => navigate(item.route)}
              aria-current={active ? 'page' : undefined}
              sx={{
                background: 'none', cursor: 'pointer',
                border: 'none', borderBottom: '2px solid',
                borderBottomColor: active ? P.accent : 'transparent',
                px: 0.25, py: 0.5, whiteSpace: 'nowrap',
                fontFamily: 'inherit', fontSize: '13px',
                color: active ? '#ffffff' : P.navFgIdle,
                '&:hover': { color: '#ffffff' },
              }}
            >
              {t(item.key)}
            </Box>
          );
        })}
      </Box>

      <LangSwitch dark />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <LockOutlinedIcon sx={{ fontSize: 15, color: P.navFgIdle }} />
        <Typography sx={{
          fontSize: '12px', color: '#ffffff',
          border: `1px solid ${P.navBorder}`, borderRadius: '4px', px: 1.25, py: 0.4,
        }}>
          {TENANT}
        </Typography>
      </Box>
    </Box>
  );
};

export default HomeNav;
